import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import LayOut from "../components/LayOut";
import axios from "axios";
import toast from "react-hot-toast";

const Register = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    phone: "",
  });
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.name ||
      !formData.email ||
      !formData.password ||
      !formData.phone
    ) {
      return toast.error("All fields are required");
    }

    try {
      const response = await axios.post(
        "https://portfoliomern-mxue.onrender.com/api/v1/auth/register",
        {
          name: formData.name,
          email: formData.email,
          password: formData.password,
          phone: formData.phone,
        }
      );

      console.log("API Response:", response);

      if (response.data?.success) {
        toast.success(response.data.message || "User registered successfully!");
        navigate("/login");
      } else {
        toast.error(response.data?.message || "Registration failed.");
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong. Please try again.");
    }

    setFormData({
      name: "",
      email: "",
      password: "",
      phone: "",
    });
  };

  return (
    <LayOut>
      <div
        className="register-page"
        style={{
          backgroundColor: "#101010",
          minHeight: "100vh",
          padding: "50px",
        }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6">
              <div
                className="card p-4 shadow-lg"
                style={{ backgroundColor: "#333", borderRadius: "8px" }}
              >
                <h2 className="text-center text-white mb-4">Register</h2>
                <form onSubmit={handleSubmit}>
                  <div className="form-group mb-3">
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      placeholder="Name"
                      value={formData.name}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group mb-3">
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      placeholder="Email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group mb-3">
                    <input
                      type="password"
                      className="form-control"
                      name="password"
                      placeholder="Password"
                      value={formData.password}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group mb-4">
                    <input
                      type="text"
                      className="form-control"
                      name="phone"
                      placeholder="Phone Number"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>

                  <button type="submit" className="btn btn-pink btn-1 w-100">
                    Submit
                  </button>
                </form>

                <p className="text-center text-white mt-3">
                  Already have an account?{" "}
                  <Link to="/login" className="text-pink">
                    Login
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LayOut>
  );
};

export default Register;
